import RoutesConfig from './RoutesConfig';
import './styles/common.scss';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import 'react-quill/dist/quill.snow.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const theme = createTheme({
  palette: {
    primary: {
      main: '#AE2828',
    },
  },
  typography: {
    fontFamily: "'Manrope', sans-serif",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        maxSnack={1}
      >
        <LocalizationProvider
          dateAdapter={AdapterMoment}
        >
          <RoutesConfig />

        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
